import React from 'react'
import { Box } from '@mui/material'
import { useSingleResource } from 'shared/api/list'
import { PartnerType } from './types'

export function Partner() {
  const { item } = useSingleResource<PartnerType>()
  return <Box>{`Partner: ${item?.id}`}</Box>
}
